import React, { forwardRef } from 'react';
import BarChart from './BarChart';
import LineChart from './LineChart';
import PieChart from './PieChart';
import TableView from './TableView';
import TextDisplay from './TextDisplay';
import { ChartMetadata, VisualizationType } from 'models/ai-chat/visualization.types';
import ColumnChart from './ColumnChart';
import { FilterItem } from 'models/ai-chat/filter-request';
import { TableViewRef, LlmPayload } from './TableView';



interface VisualizationProps {
  data: any;
  type: VisualizationType | string;
  sqlquery?:string | undefined;
  messageId?: string;
  metadata: ChartMetadata | null;
  onFilterValueChange?: (_filter: any, _newValue: string) => void;
  onFilterUpdateComplete?: (_updatedData: any) => void;
  filterData?: FilterItem[];
  customerId?: string;
  onExportExcel?: () => void;
  onDownloadPDF?: () => void;
  onFullView?: () => void;
  containerHeight?: number;
  llmPayload?: LlmPayload;
}

const Visualization = forwardRef<TableViewRef, VisualizationProps>(({ 
  type, 
  data, 
  sqlquery, 
  messageId,
  metadata,
  onFilterValueChange,
  onFilterUpdateComplete,
  filterData,
  customerId,
  onExportExcel,
  onDownloadPDF,
  onFullView,
  containerHeight,
  llmPayload
}, ref) => {

  // console.log('Rendering Visualization:', { type, data, sqlquery, messageId, metadata });
  // if (!data) {
  //   return (
  //     <div className="text-sm p-2 bg-gray-100 dark:bg-gray-800 rounded">
  //       No data available for visualization
  //     </div>
  //   );
  // }

  switch (type) {
    case 'barchart':
          return  <BarChart 
            data={data} 
            showDataLabels={true} 
            labelsMode="values"
            containerHeight={containerHeight}
          />;
    case 'columnchart':
       return <ColumnChart 
         data={data} 
         showDataLabels={true} 
         labelsMode="values"
         containerHeight={containerHeight}
       />;
    case 'linechart':
      return <LineChart 
        data={data} 
        showDataLabels={true} 
        labelsMode="smart"
        containerHeight={containerHeight}
      />;
    case 'piechart':
      return <PieChart 
        data={data} 
        showDataLabels={true} 
        labelsMode="names-percentages"
        containerHeight={containerHeight}
      />;
    case 'table':
      return <TableView 
        ref={ref}
        data={data} 
        sqlQuery={sqlquery}
        messageId={messageId}
        onFilterValueChange={onFilterValueChange}
        onFilterUpdateComplete={onFilterUpdateComplete}
        filterData={filterData}
        customerId={customerId} 
        pdfGeneration={metadata?.pdf_generation || false}
        onExportExcel={onExportExcel}
        onDownloadPDF={onDownloadPDF}
        onFullView={onFullView}
        llmPayload={llmPayload}
      />;
    case 'text':
      return <TextDisplay data={data} />;
    default:
     return <TableView 
        ref={ref}
        data={data} 
        sqlQuery={sqlquery}
        messageId={messageId}
        onFilterValueChange={onFilterValueChange}
        onFilterUpdateComplete={onFilterUpdateComplete}
        filterData={filterData}
        customerId={customerId} 
        pdfGeneration={metadata?.pdf_generation || false}
        onExportExcel={onExportExcel}
        onDownloadPDF={onDownloadPDF}
        onFullView={onFullView}
        llmPayload={llmPayload}
      />;
  }
});

Visualization.displayName = 'Visualization';

export default Visualization;